import React from 'react';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-white rounded-xl border border-[#e5e5e5] animate-in fade-in zoom-in-95 duration-300" data-id="element-567">
      <div className="h-16 w-16 rounded-full bg-[#062133]/5 flex items-center justify-center mb-4" data-id="element-568">
        <Icon className="h-8 w-8 text-[#5a7280]" data-id="element-569" />
      </div>
      <h3 className="text-lg font-bold text-[#062133] mb-2" data-id="element-570">{title}</h3>
      <p className="text-[#5a7280] max-w-sm mb-6" data-id="element-571">{description}</p>

      {actionLabel && onAction && <button onClick={onAction} className="px-5 py-2.5 text-sm font-medium text-white bg-[#ff697f] rounded-xl hover:bg-[#e65a6f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ff697f] transition-colors shadow-sm" data-id="element-572">
          {actionLabel}
        </button>}
    </div>;
}